import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import TicketProgressDisplay from "components/Parts/TicketProgressDisplay";
import ReactTable from "react-table";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import moment from 'moment';
import Edit from '@material-ui/icons/Edit'
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {Link} from "react-router-dom";
import CalendarToday from "@material-ui/icons/CalendarToday";
import Select from "react-select";

export default class FELocationTable extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Information._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_PROGRESS'
		this.state.limit = 16;
		this.state.region = {
			pkey: 1,
			name: "Phoenix (602, 480, 623)",
			latitude: "33.4484000",
			longitude: "-112.0740000",
		};
		this.state.data = [];
	}

	async componentDidMount() {
		await this.getRegions();
		await this.fetchData();
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter((region) => {
				return region.latitude > 0 || region.latitude < 0
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
	}

	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof(this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.region = this.state.region.pkey;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	refreshPage = () => {
		this.fetchData().then();
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Field Engineer",
				id: 'assigned_to', // Can't use correct column, comes from virtual column
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.fe_name,
			},
			{
				Header: "Customer",
				id: 'customer_name',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.customer_name,
				Cell: (props) => {
					let {original} = props;
					let {Customer, customer_name} = original;
						return (
							<span>
								<Link to={`/customers/${Customer}`}>
									{customer_name}
								</Link>
							</span>
						);
				}
			},
			{
				Header: "Appointment Start",
				id: 'AppointmentStart',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.AppointmentStart ? moment(obj.AppointmentStart).tz(obj.timezone ?? "America/Phoenix").format('h:mm A') : '',
			},
			{
				Header: "Appointment End",
				id: 'AppointmentEnd',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.AppointmentEnd ? moment(obj.AppointmentEnd).tz(obj.timezone ?? "America/Phoenix").format('h:mm A') : '',
			},
			{
				Header: "Freshdesk Ticket",
				id: "FreshTicket",
				/** @param {Tickets_Object} props.original */
				Cell: props => <FreshdeskTicketLink freshTicket={props.original.FreshTicket} />
			},
			{
				Header: "Status",
				className: 'button-cell',
				filterable: false,
				sortable: false,
				width: 300,
				Cell: props => {
					const {progress} = props.original
					return (
						<span>
							<TicketProgressDisplay
								progress={progress}
								emptyLabel="FE has not started heading to this WO."
								titleSize="17px"
								barFontSize="18px"
							/>
						</span>
					)
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/tickets/" + props.original.Pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: (props) => {
					return (
						<span>
							<Link to={"/dispatch/calendar/" + props.original.Pkey}>
								<Button color="primary" size={"sm"} block={true} onClick={() => {
									//so the window pops up
									localStorage.setItem('ticketToggled', 'no');
									localStorage.removeItem('users'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('regions'); //doing this so that ticket correctly pops after creation no matter what
									localStorage.removeItem('date'); //doing this so that ticket correctly pops after creation no matter what
								}}>
									<CalendarToday fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className={"table-bar"}>
						<div className={'row'}>
							<div className={'col-3'}>
								<Select
									key={this.state.regions}
									placeholder={"Region Select"}
									value={{value: this.state.region.pkey, label: this.state.region.name}}
									onChange={(value) => {
										this.setState({region: this.state.regions.find((region) => region.pkey === value.value)}, async () => {
											await this.fetchData();
										})
									}}
									options={this.state.regions?.map(region => {
										return (
											{value: region.pkey, label: region.name}
										)
									})}
									styles={{control: styles => ({...styles, lineHeight: '30px'})}}
								/>
							</div>
							<div className={'col-8'}>

							</div>
							<div className={'col-1 d-flex justify-content-end align-content-center'} style={{flexWrap: 'wrap'}}>
								<Button onClick={async () => {
									await this.refreshPage();
								}} size={"sm"} color="primary">
									<i className="fa fa-users"/>Refresh Data
								</Button>
							</div>
							{/*<div className={'col-6'}>
								<Select
									key={this.state.orderBy}
									placeholder={"Pan To FE"}
									value={this.state.selectedFe ? {
										value: this.state.selectedFe.pkey,
										label: this.state.selectedFe.name_first + " " + this.state.selectedFe.name_last
									} : {value: null, label: "Select a FE to pan to..."}}
									onChange={(value) => {
										this.setState({selectedFe: this.state.items.find((fe) => fe.pkey === value.value)}, () => {
											this.panToFE()
										})
									}}
									options={this.state.fes?.filter((fe) => {
										if (!this.state.items) {
											return true
										}
										let currentFe = this.state.items.find(item => item.pkey === fe.resourceId)
										if (currentFe) {
											if (currentFe.currentCoords[0] || currentFe.homeLatLong?.latitude || currentFe.latitude) {
												return true
											}
										} else {
											return false
										}
									}).map(fe => {
										return ({value: fe.resourceId, label: fe.resourceTitle})
									})}
									styles={{ control: styles => ({ ...styles, lineHeight: '30px' })}}
								/>
							</div>*/}
						</div>
					</div>
					{data.length > 0 ?
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
							onPageSizeChange={this.onPageSizeChange}
							pageSize={data.length}
						/> :
					<b>There are no appointments for this region today.</b>}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
